import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";

import { Grid, Box, TableCell, TableRow, TableBody, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import { Image_API } from "../../../config";
import Admin from "../../../components/auth/Admin";
import Catagory from "../../../actions/Catagory";
import AddMaincatagory from "../../../components/forms/AddCatagory";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import InfoComponent from "../../../components/InfoComponent";
import { Search } from "@mui/icons-material";

const headCells = [
  { id: "name", label: "Name" },
  { id: "image", label: "Image" },
  { id: "description", label: "Description" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "30px",
    width: "30px",
  },
}));

const Category = () => {
  const history = useHistory();
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllCatagories, deleteCatagory } = Catagory();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [categories, setCategories] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllCategories();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllCategories = () => {
    setValues({ ...values, loading: true });
    viewAllCatagories().then((data) => {
      if (data.err) {
        setValues({
          ...values,
          loading: false,
        });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.categorys) {
        setValues({
          ...values,
          loading: false,
        });
        setCategories(data.categorys);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteCatagory(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setCategories(
          produce(categories, (draft) => {
            const index = categories.findIndex(
              (catagory) => catagory.id === Id
            );
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(categories, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["name"];
        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 0 },
              "& > .newButton": {
                marginLeft: { xs: "auto", sm: "0" },
              },
              "@media (max-width: 455px)": {
                flexDirection: "column",
                alignItems: "flex-start",
              },
            }}
          >
            <Typography
              variant="h6"
              className="page-header"
              sx={{ whiteSpace: "nowrap" }}
            >
              Categories
            </Typography>
            <Controls.Button
              text="Add Category"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
              }}
            />
          </Box>
          <InfoComponent pageKey="categories" />

          <div
            className="search-header-container"
            style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
          >
            <div className="search-header-flex">
              <div className="search-container">
                <Search className="search_icon" />
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Categories"
                  className="search-input"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.Id}>
                            <TableCell
                              style={{ minWidth: 150 }} 
                            >
                              {item.name}
                            </TableCell>
                            <TableCell
                              style={{ minWidth: 100 }} 
                            >
                              <img
                                className={classes.image}
                                src={`${Image_API}/${item.image}`}
                                alt={item.image}
                              />
                            </TableCell>
                            <TableCell
                              style={{ minWidth: 300 }} // Ensures Description column has enough space
                            >
                              {item.description}
                            </TableCell>
                            <TableCell
                              style={{ minWidth: 150, whiteSpace: "nowrap" }} // Ensures Actions column has enough space
                            >
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title:
                                      "Are you sure to delete this Category?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Update"
                                onClick={() => {
                                  setOpenPopup(true);
                                  setRecordForEdit(item);
                                  setEdit(true);
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/categories/${item.name}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={4} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Category Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddMaincatagory
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setCategories={setCategories}
            edite={edite}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default Category;
